import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ShieldHalf } from "lucide-react";
import { Seo } from "../components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => { if (res.data.is_admin) navigate("/admin", { replace: true }); })
      .catch(() => {});
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-[#05071F] min-h-screen flex items-center justify-center font-body px-6">
      <Seo title="Admin Sign In | Silent Sentry" description="Restricted admin area." noindex />
      <div data-testid="admin-login-card" className="w-full max-w-md border border-white/10 bg-[#0B1035] p-10 text-center">
        <ShieldHalf className="w-10 h-10 text-cyan-400 mx-auto" />
        <h1 className="mt-6 font-heading text-2xl font-medium text-white tracking-tight">Silent Sentry Admin</h1>
        <p className="mt-3 text-sm text-slate-400">Restricted area. Sign in with an authorized Google account to access the inquiry dashboard.</p>
        <button onClick={login} data-testid="google-login-btn"
          className="mt-8 w-full inline-flex items-center justify-center gap-3 bg-white text-[#05071F] font-semibold px-6 py-3.5 rounded-full hover:bg-slate-200 transition-colors">
          <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0012 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 010-4.2V7.06H2.18a11 11 0 000 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 002.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/></svg>
          Sign in with Google
        </button>
        <a href="/" className="mt-6 inline-block text-sm text-slate-500 hover:text-white transition-colors">← Back to site</a>
      </div>
    </div>
  );
}
